import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Alert, Badge, Card, CardBody, CardSubtitle, CardText, CardTitle, Col, Container, Row} from 'reactstrap';
import OralbIcon from './oralb.webp';
import OralbStepOne from './oralb_step1.png'
import OralbStepTwo from './oralb_step2.png'

const linkStyle = {
    display: 'inline-block', overflow: 'hidden', borderRadius: '13px', height: '100px',
};

const appLinkImageStyle = {
    borderRadius: '13px', height: '100px',
};

const centerStyle = {
    display: 'flex', justifyContent: 'center'
}

const rowStyle = {
    padding: "1%"
}

const endNoteStyle = {
    display: 'flex',
    alignItems: 'flex-end',
    margin: 'auto'
}

function OralB() {
    return <Container id="main-container" fluid={true}>
        <div>
            <Row id="scorecard-header-row" style={rowStyle}>
                <Col>
                    <img alt="DDX logo" src="/ddx_scorecard.png"/>
                    <h1 id="scorecard-title">Smartbrush</h1>
                </Col>
                <Col xs="auto">
                    <div>
                        <img id="brush-mfg-img" alt="oralb logo" src={OralbIcon}/>
                    </div>
                </Col>
            </Row>
            <Row style={rowStyle}>
                <Col style={centerStyle}>
                    <Card style={{
                        width: '100%'
                    }}>
                        <CardBody style={centerStyle}>
                            <a target="_blank"
                               href='https://play.google.com/store/apps/details?id=com.pg.oralb.oralbapp&hl=en_CA&gl=US&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'
                               style={linkStyle}>
                                <img
                                    alt='Get it on Google Play'
                                    src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'
                                    style={appLinkImageStyle}/>
                            </a>
                            <a target="_blank"
                               href="https://apps.apple.com/us/app/oral-b/id698092608?itsct=apps_box_badge&itscg=30200"
                               style={linkStyle}>
                                <img
                                    src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&releaseDate=1378944000"
                                    alt="Download on the App Store"
                                    style={{padding: "5.5%", ...appLinkImageStyle}}/>
                            </a>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Row style={rowStyle}>
                <Col style={centerStyle}>
                    <Card
                        style={{
                            width: '100%'
                        }}
                    >
                        <CardBody>
                            <CardTitle tag="h1">
                                <Badge color="primary">Step 1</Badge>
                            </CardTitle>
                            <CardSubtitle
                                className="mb-2"
                                tag="h3"
                            >Start by downloading the Oral-B app. Follow the instructions within the app to connect your
                                iO brush.</CardSubtitle>
                        </CardBody>
                        <CardBody style={{justifyContent: 'center', display: 'flex'}}> <img id="oralb_step1"
                                                                                            alt="oralb step 1"
                                                                                            src={OralbStepOne}/></CardBody>
                        <CardBody style={endNoteStyle}>
                            <CardText>
                                <Alert color="primary">
                                    Note - During Oral-B app setup, Analytics should be checked
                                </Alert>
                            </CardText>
                        </CardBody>
                    </Card>
                </Col>
                <Col style={centerStyle}>
                    <Card
                        style={{
                            width: '100%'
                        }}
                    >
                        <CardBody>
                            <CardTitle tag="h1">
                                <Badge color="primary">Step 2</Badge>
                            </CardTitle>
                            <CardSubtitle
                                className="mb-2"
                                tag="h3"
                            >After brush setup, navigate to the 'More' tab. Long press on the
                                app icon and provide a screenshot of the Handle ID.</CardSubtitle>
                        </CardBody>
                        <CardBody style={{justifyContent: 'center', display: 'flex'}}> <img id="oralb_step2"
                                                                                            alt="oralb step 2"
                                                                                            src={OralbStepTwo}/></CardBody>
                    </Card>
                </Col>
                <Col style={centerStyle}>
                    <Card
                        style={{
                            width: '100%'
                        }}
                    >
                        <CardBody>
                            <CardTitle tag="h1">
                                <Badge color="primary">Step 3</Badge>
                            </CardTitle>
                            <CardSubtitle
                                className="mb-2"
                                tag="h3"
                            >At least 24 hours before your dental visit, open the
                                app with your brush handle nearby to sync sessions.</CardSubtitle>
                        </CardBody>
                        <CardBody style={endNoteStyle}>
                            <CardText>
                                <Alert color="primary">Confirm data has been synced by visiting the History tab</Alert>
                            </CardText>
                        </CardBody>

                    </Card>
                </Col>
            </Row>

            {/*<Row id="scorecard-footer-row">*/}
            {/*    <Col>*/}
            {/*    </Col>*/}
            {/*    <Col xs="auto">*/}
            {/*        <img id="hs-logo" alt="Henry Schein logo" src="henryschein.png" width="167" height="27"/>*/}
            {/*    </Col>*/}
            {/*</Row>*/}
        </div>
    </Container>
}

export default OralB;